import { render, staticRenderFns } from "./FieldIntroduce.vue?vue&type=template&id=1f8ca6de&scoped=true"
import script from "./FieldIntroduce.vue?vue&type=script&lang=js"
export * from "./FieldIntroduce.vue?vue&type=script&lang=js"
import style0 from "./FieldIntroduce.vue?vue&type=style&index=0&id=1f8ca6de&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f8ca6de",
  null
  
)

export default component.exports